module.exports = __webpack_public_path__ + "assets/img/form.58c7b396.png";